// src/components/Layout/BackgroundImageToggleButton.js
import React from 'react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconPhoto, IconPhotoOff } from '@tabler/icons-react';
import { useBackgroundImage } from '../../context/BackgroundImageContext'; // Adjust path if context is elsewhere

function BackgroundImageToggleButton() {
  const { isBackgroundImageVisible, toggleBackgroundImage } = useBackgroundImage();

  return (
    <Tooltip
      label={isBackgroundImageVisible ? "Hide Background Image" : "Show Background Image"}
      position="bottom"
      withArrow
    >
      <ActionIcon
        onClick={toggleBackgroundImage}
        variant="default" // Match styling of your ThemeToggleButton
        size="lg"       // Match styling of your ThemeToggleButton
        aria-label="Toggle background image"
      >
        {/* Shows current state: IconPhoto if ON, IconPhotoOff if OFF */}
        {isBackgroundImageVisible ? <IconPhoto size="1.25rem" /> : <IconPhotoOff size="1.25rem" />}
      </ActionIcon>
    </Tooltip>
  );
}

export default BackgroundImageToggleButton;